<template>
  <div class="admin-layout">
    <top-menu
      v-if="$screen.width >= 576"
      :openSidemenu="openSidemenu"
      :showMenu="showMenu"
    />
    <top-menu-phone
      v-else
      :openSidemenu="openSidemenu"
      :closedMenuMovil="closedMenuMovil"
      :showMenu="showMenu"
    />

    <div class="admin-layout__body">
      <aside v-show="showMenu && $screen.width >= 576" class="admin-layout__sidebar">
        <side-menu :showMenu="showMenu" />
      </aside>

      <main class="admin-layout__content" :class="{ 'admin-layout__content--full': !showMenu || $screen.width < 576 }">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import TopMenu from './TopMenu'
import TopMenuPhone from './TopMenuPhone'
import SideMenu from './SideMenu'

export default {
  name: 'admin-layout',
  components: {
    TopMenu,
    SideMenu,
    TopMenuPhone,
  },
  data() {
    return {
      showMenu: true,
    }
  },
  methods: {
    closedMenuMovil() {
      this.showMenu = !this.showMenu
    },
    openSidemenu(e) {
      if (e && e.preventDefault) e.preventDefault()
      this.showMenu = !this.showMenu
    },
  },
}
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
  background: #f5f7fa;
}

.admin-layout__body {
  display: flex;
  min-height: calc(100vh - 64px);
  padding-top: 64px;
}

.admin-layout__sidebar {
  width: 248px;
  flex: 0 0 248px;
  background: #ffffff;
}

.admin-layout__content {
  min-width: 0;
  flex: 1;
  padding: 16px 16px 24px;
}

.admin-layout__content--full {
  padding-left: 16px;
}

@media (max-width: 575px) {
  .admin-layout__body {
    padding-top: 64px;
  }

  .admin-layout__content,
  .admin-layout__content--full {
    width: 100%;
    padding: 0;
  }
}
</style>
